## Preferences

The preferences page is used to configure application preferences and individual plugin preferences.

The preferences page is accessible by clicking the user icon in the main navigation bar (the top-right corner), and then by choosing the preferences sub menu option.
